'use client';

import { useSyncExternalStore } from 'react';
import {
  ensureProductListingSearchParamsHistoryPatch,
  getProductListingSearchParamsSnapshot,
  PRODUCT_LISTING_SEARCH_PARAMS_SERVER_SNAPSHOT,
  subscribeProductListingSearchParams,
} from '@/utils/product-listing-search-params-store';

/**
 * Reads product-listing query params without `useSearchParams()`, so the
 * surrounding page can be statically prerendered at build time (default
 * page/sort/filter state). Subscribes to `history.pushState` / `popstate`.
 */
const useProductListingSearchParams = (): URLSearchParams => {
  ensureProductListingSearchParamsHistoryPatch();

  return useSyncExternalStore(
    subscribeProductListingSearchParams,
    getProductListingSearchParamsSnapshot,
    () => PRODUCT_LISTING_SEARCH_PARAMS_SERVER_SNAPSHOT,
  );
};

export default useProductListingSearchParams;
